<template>
  <div class="card">
    <header class="header-card">
      <p>{{ $t('addEditAudit.dispositif.title')}}</p>
    </header>
    <div class="card-content">
      <div class="columns">
        <div class="column is-6">
          <div class="columns">
            <div class="column is-narrow">
              <selecteur-action
                @handleAction="handleActions"
                :options='actions'
                :placeholder='$t("general.placeHolder.groupedAction")'
                :titleButton="'general.button.apply'"
                :elementsSelectionnes="hasSomethingSelected"
              ></selecteur-action>
            </div>
            <div class="column is-4">
              <div v-if="audit.otPatrimoine.otsAuditEnfants.length > 0">
                <div class="field has-addons">
                  <div class="control inputSearch has-icons-left is-clearfix">
                    <b-input :placeholder="$t('addEditAudit.dispositif.actions.search')"
                             v-model="search" type="search">
                    </b-input>
                    <b-icon class="icon is-left"
                            icon="magnify"></b-icon>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-6">
          <div class="columns is-justify-content-flex-end">
            <b-autocomplete
                class="dropdown is-bottom-left column is-5"
                v-model="searchAutocomplete"
                :open-on-focus="false"
                :data="autocompleteList"
                :loading="isFetching"
                @select="selectAutocomplete"
                @input="getElements"
                :placeholder="$t('addEditAudit.dispositif.actions.associer')">
              <template #default="{ option }">
                <div v-if="option.id">
                  {{ option.code }}
                  <span v-if="option.libelle"> - {{option.libelle}}</span>
                  <span v-if="option.adresse"> - {{adressFullStringGetter(option.adresse)}}</span>
                </div>
                <div v-else class="dropdown-item is-paddingless
                     is-disabled has-text-default has-text-weight-bold is-underline">
                  <b>{{option.title}}</b>
                </div>
              </template>
              <template #empty>
                <div v-if="!isFetching">{{$t('general.autocomplete.noRslt')}}</div>
                <div v-else>{{$t('general.autocomplete.search')}}</div>
              </template>
            </b-autocomplete>
            <div class="column is-narrow">
              <dropdownButton
                type="is-primary"
                :actions="actionSecondary"
                @click="ajouterDispositif">
                  {{ $t('addEditAudit.dispositif.actions.addDispositifMultiple') }}
              </dropdownButton>
            </div>
          </div>
        </div>
      </div>
      <div class="has-text-centered has-background-background pdt-20px pdb-20px"
           v-if="audit.otPatrimoine.otsAuditEnfants.length === 0">
        <h1 class="title is-size-4">
          {{ $t('addEditAudit.dispositif.aucunDispositif')}}
        </h1>
        <p> {{ $t('addEditAudit.dispositif.addDispositif')}} </p>
      </div>
      <div v-else-if="filteredEmplacement.length > 0">
        <div class="mgl-10px" v-if="emplacements.length > 0">
          <header-emplacement-dispositif-materiel-face-picker :emplacements="filteredEmplacement">
          </header-emplacement-dispositif-materiel-face-picker>
        </div>
        <ligne-emplacement :emplacement="emplacement" class="mgt-15px"
                           :afficherAffectation="false"
                           :index="index"
                           :afficherCheckboxMateriel="false"
                           :afficherCheckboxFace="false"
                           v-for="(emplacement, index) in filteredEmplacement" :key="index">
        </ligne-emplacement>
        <scrollLoader :loader-method="addEmplacementToLoad" :loader-disable="loaderStatus
      || filteredEmplacement.length < currrentPageSize"
                      :loader-distance="400" :loader-size="50">
        </scrollLoader>
      </div>
      <div class="has-text-centered has-background-background pdt-20px pdb-20px"
           v-else>
        <h1 class="title is-size-4">
          {{ $t('general.autocomplete.noRslt')}}
        </h1>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import debounce from 'lodash/debounce';
import { getAll as getAllDispositif } from '@/api/gabed/dispositif';
import { getAllType as getAllReseau, getAllDispositifFromReseau } from '@/api/produit/produitReseau';
import messageErreur from '@/services/general/messageErreur';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import { SET_AUDIT_COURANT } from '@/store/modules/logistique/audit-mutation-type';
import scrollLoader from '@/components/general/scrollLoader';
import {
  getEmplacementDispositifMaterielAndFaceFromListeDispositif,
  createEmplacementDispositifMaterielFace,
} from '@/services/logistique/audit/getEmplacementDispositifMaterielFaceFromListDispositif';
import ligneEmplacement from '@/components/gabed/general/ligneEmplacement';
import cloneDeep from 'lodash/cloneDeep';
import selecteurAction from '@/components/general/selecteurAction';
import { ACTION_DELETE } from '@/configuration/general/actionsConf';
import headerEmplacementDispositifMaterielFacePicker
  from '@/components/gabed/general/headerEmplacementDispositifMaterielFacePicker';
import messageSucces from '@/services/general/messageSucces';
import genererOTTech from '@/services/logistique/ordreTravail/tech/genererObject/genererOTTech';
import genererOtPatrimoine
  from '@/services/logistique/ordreTravail/tech/genererObject/genererOTPatrimoine';
import dropdownButton from '@/components/general/button/dropdownButton';
import formatDate from '@/services/general/formatIsoDate';
import addGenerationOtFromDispositifAudit from '@/services/logistique/audit/addGenerationOtFromDispositifAudit';
import {
  CATEGORIE_REGROUPEMENT,
  CATEGORIE_REGROUPEMENT_LC,
  CATEGORIE_REGROUPEMENT_MAIRIE,
  CATEGORIE_REGROUPEMENT_NUMERIQUE,
} from '@/configuration/catalogue/produitConf';
import { AMONTE, MONTE } from '@/configuration/gabed/dispositif/dispositifPublicitaire';
import filtrePatrimoineEmplacementSansMaterielDemonte, { filtrePatrimoineDispositifSansMaterielDemonte } from '@/services/logistique/audit/filtrePatrimoineSansDemonte';

const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');
const Audit = createNamespacedHelpers('audit');

export default {
  name: 'LogistiqueAuditEditPatrimoine',
  props: {
    audit: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      search: '',
      searchAutocomplete: null,
      autocompleteList: [],
      selectedDispositif: null,
      isFetching: false,
      loaderStatus: false,
      currrentPageSize: 20,
      rangeToAddAfterEndOfScroll: 5,
      emplacements: [],
      types: {
        DISPOSITIF: 'dispositif',
        RESEAU: 'reseau',
      },
      produitReseauCategories: [
        CATEGORIE_REGROUPEMENT,
        CATEGORIE_REGROUPEMENT_LC,
        CATEGORIE_REGROUPEMENT_MAIRIE,
        CATEGORIE_REGROUPEMENT_NUMERIQUE,
      ],
      actions: [
        { action: ACTION_DELETE, translation: 'general.button.delete' },
      ],
      adressFullStringGetter,
    };
  },
  components: {
    ligneEmplacement,
    selecteurAction,
    scrollLoader,
    headerEmplacementDispositifMaterielFacePicker,
    dropdownButton,
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    filteredEmplacement() {
      return this.emplacements.filter((emplacement) => {
        const dispositif = emplacement.dispositifs.filter((dispositif) => {
          return dispositif.code
            && dispositif.code.toLowerCase().includes(this.search.toLowerCase());
        });
        return dispositif.length > 0;
      }).slice(0, this.currrentPageSize);
    },
    hasSomethingSelected() {
      return this.emplacements.filter((emplacement) => {
        const dispositif = emplacement.dispositifs.filter((dispositif) => {
          return dispositif.selected;
        });
        return dispositif.length > 0 || emplacement.selected;
      }).length > 0;
    },
    actionSecondary() {
      return [
        {
          label: this.$t('addEditAudit.dispositif.actions.addReseauMultiple'),
          action: this.ajouterReseau,
        },
      ];
    },
  },
  methods: {
    ...Audit.mapMutations({
      setAudit: SET_AUDIT_COURANT,
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    deleteSelectedDispositif() {
      this.emplacements.forEach((emplacement) => {
        emplacement.dispositifs = emplacement.dispositifs.filter((dispositif) => {
          return !dispositif.selected;
        });
      });
      this.emplacements = this.emplacements.filter((emplacement) => {
        return !emplacement.selected;
      });
      this.saveDispositifInAudit();
    },
    saveDispositifInAudit() {
      const dispositifs = [];
      this.emplacements.forEach((emplacement) => {
        emplacement.dispositifs.forEach((dispositif) => {
          dispositifs.push({
            dispositif: dispositif,
            dispositifId: dispositif.id,
          });
        });
      });
      this.audit.otPatrimoine.otsAuditEnfants = this.audit.otPatrimoine.otsAuditEnfants
        .filter(ot => {
          return dispositifs.map(d => d.dispositifId).includes(ot.otPatrimoine.dispositifId);
        });
      dispositifs
        .filter(d => {
          return !this.audit.otPatrimoine.otsAuditEnfants
            .map(ot => ot.otPatrimoine.dispositifId)
            .includes(d.dispositifId);
        })
        .forEach(d => {
          const ot = genererOTTech();
          ot.otPatrimoine = genererOtPatrimoine();
          ot.otPatrimoine.dispositifId = d.dispositifId;
          ot.otPatrimoine.dispositif = d.dispositif;
          this.audit.otPatrimoine.otsAuditEnfants.push(ot);
        });
    },
    handleActions(action) {
      switch (action) {
        case ACTION_DELETE:
          this.deleteSelectedDispositif();
          break;
        default:
          break;
      }
    },
    addEmplacementToLoad() {
      if (this.currrentPageSize >= this.emplacements.length) {
        this.loaderStatus = true;
        this.currrentPageSize = this.emplacements.length;
        return;
      }
      this.currrentPageSize += this.rangeToAddAfterEndOfScroll;
    },
    ajouterDispositif() {
      this.setAudit(this.audit);
      this.$router.push({ name: 'm.logistique.ordre_travail_audit-addDispositif' });
    },
    ajouterReseau() {
      this.setAudit(this.audit);
      this.$router.push({ name: 'm.logistique.ordre_travail_audit-addReseau' });
    },
    async getFormatedDispositif(search) {
      const payload = {
        query: {
          auto: search,
          etats: [MONTE, AMONTE],
          societeId: this.societeActiveId,
          actif: true,
        },
      };
      const dispositifs = (await getAllDispositif(payload)).data.result.items;
      const filteredDispositifs = dispositifs.filter((dispositif) => {
        return !this.audit.otPatrimoine.otsAuditEnfants.find((ot) => {
          return ot.otPatrimoine.dispositifId === dispositif.id;
        });
      });
      filteredDispositifs.forEach((dispositif) => {
        dispositif.elementType = this.types.DISPOSITIF;
        dispositif.libelle = dispositif?.dispositifType?.libelle;
      });
      if (filteredDispositifs.length > 0) {
        filteredDispositifs.unshift({ title: this.$t('addEditAudit.dispositif.group.dispositif') });
      }
      return filteredDispositifs;
    },
    async getFormatedReseau(search) {
      const payload = {
        query: {
          auto: search,
          societeId: this.societeActiveId,
          dateVisualisation: formatDate(new Date()),
          categories: this.produitReseauCategories,
          actif: true,
        },
      };
      const reseaux = (await getAllReseau(payload)).data.result.items;
      reseaux.forEach((reseau) => {
        reseau.elementType = this.types.RESEAU;
        reseau.code = reseau.reference;
        reseau.adresse = reseau?.produitReseauNumerique?.adresse ?? reseau?.produitReseau?.adresse;
      });
      if (reseaux.length > 0) {
        reseaux.unshift({ title: this.$t('addEditAudit.dispositif.group.reseau') });
      }
      return reseaux;
    },
    getElements: debounce(async function elementData() {
      try {
        this.autocompleteList = [];
        if (this.searchAutocomplete?.length === 0) return;
        this.isFetching = true;
        const [reseau, dispositif] = await Promise.all([
          this.getFormatedDispositif(this.searchAutocomplete),
          this.getFormatedReseau(this.searchAutocomplete),
        ]);
        this.autocompleteList = reseau.concat(dispositif);
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        this.isFetching = false;
      }
    }, 500),

    selectDispositif(dispositifs) {
      if (!Array.isArray(dispositifs)) return;
      const dispositifsFiltres = filtrePatrimoineDispositifSansMaterielDemonte(dispositifs);
      dispositifsFiltres.forEach(dispositif => {
        if (this.audit.otPatrimoine.otsAuditEnfants?.find((ot) => {
          return ot?.otPatrimoine?.dispositifId === dispositif?.id;
        })) return;
        dispositif.selected = false;
        dispositif.open = false;
        this.addDispositifInEmplacement(dispositif);
      });
      this.audit.otPatrimoine.otsAuditEnfants = addGenerationOtFromDispositifAudit(
        dispositifsFiltres, this.audit.otPatrimoine.otsAuditEnfants,
      );
    },

    async selectReseau(reseau) {
      const payload = {
        reseauxIds: [reseau.id],
        dateVisualisation: formatDate(new Date()),
      };
      const dispositifs = (await getAllDispositifFromReseau(payload)).data.result;
      this.selectDispositif(dispositifs);
    },

    async selectAutocomplete(item) {
      if (!item?.id) return;
      const loadingComponent = this.$buefy.loading.open();
      try {
        switch (item.elementType) {
          case this.types.DISPOSITIF:
            this.selectDispositif([item]);
            break;
          case this.types.RESEAU:
            await this.selectReseau(item);
            break;
          default:
            break;
        }
        messageSucces(this.$i18n.t('addEditAudit.dispositif.successAdd'));
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    addDispositifInEmplacement(dispositif) {
      const emplacementExistant = this.emplacements.find((emplacement) => {
        return emplacement.id === dispositif.emplacementId;
      });
      if (!emplacementExistant) {
        createEmplacementDispositifMaterielFace(dispositif, this.emplacements);
        return;
      }
      emplacementExistant.dispositifs.push(dispositif);
    },
  },
  mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      const emplacement = getEmplacementDispositifMaterielAndFaceFromListeDispositif(
        cloneDeep(this.audit.otPatrimoine.otsAuditEnfants.map((ot) => ot.otPatrimoine.dispositif)),
      );
      this.emplacements = filtrePatrimoineEmplacementSansMaterielDemonte(emplacement);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};

</script>
